// import "@fontsource/noto-sans-jp"
// import "./src/styles/base.css"
// import "./src/styles/blog-contents-style.css"

// export const onRouteUpdate = () => {
//     if (typeof document !== "undefined") {
//         const elements = document.querySelectorAll(".fadeInUp");

//         const observer = new IntersectionObserver(
//             (entries) => {
//                 entries.forEach((entry) => {
//                     if (entry.isIntersecting) {
//                         entry.target.classList.add("on");
                        
//                     }
//                 });
//             },
//             { threshold: 0.1 }
//         );

//         elements.forEach((el) => observer.observe(el));

//         return () => {
//             elements.forEach((el) => observer.unobserve(el));
//         };
//     }
// };

// export const onClientEntry = () => {
//   if (typeof document !== "undefined") {
//     document.documentElement.classList.add("js");
//   }
// };
import "@fontsource/noto-sans-jp"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"

export const onClientEntry = () => {
  if (typeof document !== "undefined") {
    document.documentElement.classList.add("js");

    /* スタイルをJSから注入 */
    const style = document.createElement("style");
    style.textContent = `
      .fadeInUp {
        opacity: 0;
        transform: translateY(20px);
        filter: blur(10px);
        transition:
          opacity 2s ease,
          transform 0s cubic-bezier(0.22, 1, 0.36, 1),
          filter 1.8s ease;
      }

      .fadeInUp.on {
        opacity: 1;
        transform: translateY(0);
        filter: blur(0);
      }
    `;
    document.head.appendChild(style);
  }
};

export const onRouteUpdate = () => {
  if (typeof document !== "undefined") {
    const elements = document.querySelectorAll(".fadeInUp");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add("on");
            }, 300); // ← 表示を少し遅らせる（0.3秒）
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -60px 0px", // 少し下で発火
      }
    );

    elements.forEach((el) => observer.observe(el));
  }
};
